export default [
  // Chorus 1 1:21
  // 252 BPM (metronome)

  {m:41, t: 1, pos: 4},
  {m:41, t: 2, pos: 4},
  {m:41, t: 3, pos: 3},
  {m:41, t: 4, pos: 2},
  {m:41, t: 5, pos: 5},
  {m:41, t: 6, pos: 2},
  {m:41, t: 7, pos: 4},
  {m:41, t: 8, pos: 2},

  {m:42, t: 1, pos: 3},
  {m:42, t: 2, pos: 3},
  {m:42, t: 3, pos: 2},
  {m:42, t: 4, pos: 1},
  {m:42, t: 5, pos: 5},
  {m:42, t: 6, pos: 3},
  {m:42, t: 7, pos: 4},
  {m:42, t: 8, pos: 3},

  {m:43, t: 1, pos: 1},
  {m:43, t: 2, pos: 4},
  {m:43, t: 3, pos: 2},
  {m:43, t: 4, pos: 1},
  {m:43, t: 5, pos: 5},
  {m:43, t: 6, pos: 2},
  {m:43, t: 7, pos: 4},
  {m:43, t: 8, pos: 2},

  {m:44, t: 1, pos: 1},
  {m:44, t: 2, pos: 4},
  {m:44, t: 3, pos: 2},
  {m:44, t: 4, pos: 1},
  {m:44, t: 5, pos: 5},
  {m:44, t: 6, pos: 2},
  {m:44, t: 7, pos: 4},
  {m:44, t: 8, pos: 2},

  {m:45, t: 1, pos: 4},
  {m:45, t: 2, pos: 4},
  {m:45, t: 3, pos: 3},
  {m:45, t: 4, pos: 2},
  {m:45, t: 5, pos: 5},
  {m:45, t: 6, pos: 2},
  {m:45, t: 7, pos: 4},
  {m:45, t: 8, pos: 2},

  {m:46, t: 1, pos: 3},
  {m:46, t: 2, pos: 3},
  {m:46, t: 3, pos: 2},
  {m:46, t: 4, pos: 1},
  {m:46, t: 5, pos: 5},
  {m:46, t: 6, pos: 3},
  {m:46, t: 7, pos: 4, hold: 2},
  // {m:46, t: 8, pos: 3},

  {m:47, t: 1, pos: 3, hold: 15}, {m:47, t: 1, pos: 5, hold: 15},
  // {m:47, t: 2, pos: 3},
  // {m:47, t: 3, pos: 2},
  // {m:47, t: 4, pos: 1},
  // {m:47, t: 5, pos: 5},
  // {m:47, t: 6, pos: 3},
  // {m:47, t: 7, pos: 4},
  // {m:47, t: 8, pos: 3},

  // m:48 hold until last beat

];



//////////////////
// WEBPACK FOOTER
// ./lib/songs/song_chorus_1.js
// module id = 11
// module chunks = 0